import React, { Fragment } from 'react';
import { Icon, Image, Label, Divider } from 'semantic-ui-react';

import { ImageTypes } from '../../utils/attachmentTypes';
import Crop from '../Crop';
import { PDFThumbnail } from './PDFPreview';

const Small = ({
  src,
  attachmentType,
  id,
  onCrop,
  onClick,
  onFileError,
  editDisabled
}) => {
  if (ImageTypes.includes(attachmentType)) {
    return onCrop ? (
      <Crop
        src={src}
        onCrop={onCrop}
        onClick={onClick}
        disabled={editDisabled}
        onFileError={() => onFileError(id)}
      />
    ) : (
      <Image src={src} onClick={onClick} />
    );
  }
  if (attachmentType === 'application/pdf') {
    return (
      <PDFThumbnail src={src} scale={0.3} onFileError={() => onFileError(id)} />
    );
  }
  if (
    attachmentType === 'application/msword' ||
    attachmentType ===
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  ) {
    return (
      <Fragment>
        <Label>{attachmentType}</Label>
        <Divider hidden />
        <Icon color="grey" name="file word outline" size="massive" />
      </Fragment>
    );
  }
  return (
    <Fragment>
      <Label>{attachmentType}</Label>
      <Divider hidden />
      <Icon color="grey" name="file" size="massive" />
    </Fragment>
  );
};

export default Small;



// WEBPACK FOOTER //
// ./src/component/DocumentPreview/Small.js